"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customAssetLibraryImageOrder = void 0;
// Default-logo entries lead the list; within each group, lastUsedAt (then createdAt) recency wins.
const customAssetLibraryImageOrder = (a, b) => {
    if (a.isDefaultLogo !== b.isDefaultLogo) {
        return a.isDefaultLogo ? -1 : 1;
    }
    const aKey = a.lastUsedAt ?? a.createdAt;
    const bKey = b.lastUsedAt ?? b.createdAt;
    return bKey.localeCompare(aKey);
};
exports.customAssetLibraryImageOrder = customAssetLibraryImageOrder;
